import { StyleSheet } from 'react-native';
import { PROFILE_COLORS } from '../ProfileScreen/ProfileScreen.constants';

export const profileStatsRowStyles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    gap: 8,
    paddingHorizontal: 16,
    paddingTop: 14,
  },
  tile: {
    flex: 1,
    backgroundColor: PROFILE_COLORS.card,
    borderWidth: 1,
    borderColor: PROFILE_COLORS.cardBorder,
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 6,
    alignItems: 'center',
    gap: 2,
  },
  value: {
    fontSize: 18,
    fontWeight: '800',
    color: PROFILE_COLORS.text,
    fontVariant: ['tabular-nums'],
  },
  label: {
    fontSize: 10,
    fontWeight: '600',
    color: PROFILE_COLORS.textMuted,
  },
});
